import React, { useContext, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import ContentData from "../../../../constants/contentFile.json";
import DeactiveIcon from "../../../../assets/images/deactiveIcon.png";
import BorderButton from "../../../../components/BorderButton/BorderButton";
import "./adminView.css";
import NextIcon from "../../../../assets/images/next-icon.svg";
import { AdminManageViewContext } from "../ViewAdminView";
import SuccessPopupAlert from "../../../../components/PopupAlertSuccess/PopupAlert";
import PopupAlertError from "../../../../components/PopupAlertError/PopupAlertError";
import DeleteAlertBox from "../../../../components/AlertComponent/AlertBox";
import Loader from "../../../../components/Loader/Loader";
import EditIcon from "../../../../assets/images/editIcon.png";
import DeactivePopupImage from "../../../../assets/images/deactivePopupIcon.svg";
import ActiveUserIcon from "../../../../assets/images/activeUserIcon.png";

const AdminManageView = () => {
  const {
    adminData,
    errorPopup,
    errorPopupMessage,
    adminId,
    setErrorPopup,
    viewAdmin,
    adminTableList,
    adminToLogin,
    statusValue,
    successPopup,
    SuccessAlert,
    successPopupMessage,
    buttonText,
    spinnerStatus,
    setSuccessPopup,
    deactiveAdminData,
    editAdminData,
    setDeactiveAlert,
    deactiveAlert,
    activeAdminData,
    setActiveAlert,
    activeAlert,
    inviteActiveAdmin,
    permissionAccess,
  } = useContext(AdminManageViewContext);

  return (
    <div className="pageBg">
      <div className="breadCrums">
        <span className="breadCrumsPointing" onClick={adminTableList}>
          {ContentData.adminPage.pageTitle}
        </span>
        <img className="nextIcon " src={NextIcon} alt="next icon" />
        <span className="boldBreadCrums">
          {ContentData.adminPage.adminDetail}
        </span>
      </div>
      <Container>
        {spinnerStatus && <Loader />}
        <div className="flexPage">
          <div className="headFlexing">
            <div className="pageTittles">
              {adminData?.name ? adminData?.name : "-"}
            </div>
            <div className="subFlexing">
              {adminData?.status == "N" ? (
                <div
                  className={`deletEditSection ${
                    permissionAccess?.delete ? "" : "disabledIconOnly "
                  } `}
                  onClick={() => inviteActiveAdmin(adminData?._id)}
                >
                  Resend invite
                </div>
              ) : (
                ""
              )}
              {adminData?.status == "A" || adminData?.status == "N" ? (
                <div
                  className={`deletEditSection ${
                    permissionAccess?.delete ? "" : "disabledIconOnly "
                  } `}
                  onClick={() => setDeactiveAlert(true)}
                >
                  <img src={DeactiveIcon} alt="DeactiveIcon" />
                </div>
              ) : (
                ""
              )}
              {adminData?.status == "I" ? (
                <div>
                  <span className="activeButton">Deactivated</span>
                  <span
                    className={`deletEditSection ${
                      permissionAccess?.delete ? "" : "disabledIconOnly "
                    } `}
                    onClick={() => setActiveAlert(true)}
                  >
                    <img src={ActiveUserIcon} alt="active user" />
                  </span>
                </div>
              ) : (
                ""
              )}
              <div
                className={`deletEditSection ${
                  permissionAccess?.edit ? "" : "disabledIconOnly "
                } `}
                onClick={() => editAdminData(adminData._id)}
              >
                <img src={EditIcon} alt="edit" />
              </div>
            </div>
          </div>
        </div>
        <div className="basicContainer">
          <div className="viewDetailSection">
            <Row>
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.adminPage?.adminName}</h4>
                    <h5>{adminData?.name ? adminData?.name : "-"}</h5>
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.adminPage.emailaddress}</h4>
                    <h5>{adminData?.email ? adminData?.email : "-"}</h5>
                  </div>
                </div>
              </Col>
              <Col xl="4" lg="4" sm="12">
                <div className="adminDetailSection">
                  <div className="adminDetailSectionTop roleSubPage">
                    <h4>{ContentData?.adminPage?.role}</h4>
                    <h5>
                      {adminData?.role?.name ? adminData?.role?.name : "-"}
                    </h5>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {/* <div className="bottomButtons">
          <BorderButton
            value={ContentData.authPage.cancelText}
            onClick={adminTableList}
          />
        </div> */}
      </Container>
      <SuccessPopupAlert
        show={successPopup}
        alertMessage={successPopupMessage}
        handleSubmit={() => {
          setSuccessPopup(false);
          adminTableList();
        }}
      />
      <PopupAlertError
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401) {
            adminToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            viewAdmin(adminId);
          }
        }}
      />
      {deactiveAlert && (
        <DeleteAlertBox
          alertMessage={ContentData.adminPage.deactiveUserText}
          buttonSubmitText={ContentData.adminPage.deactiveText}
          popImage={DeactivePopupImage}
          show={deactiveAlert}
          setShow={setDeactiveAlert}
          handleSubmitData={() => deactiveAdminData(adminData._id)}
          handleCancelClick={() => setDeactiveAlert(false)}
        />
      )}
      {/* {activeAlert && ( */}
      <DeleteAlertBox
        alertMessage={"Do you want to activate this user"}
        buttonSubmitText={"Activate"}
        popImage={DeactivePopupImage}
        show={activeAlert}
        setShow={setActiveAlert}
        handleSubmitData={() => activeAdminData(adminData._id)}
        handleCancelClick={() => setActiveAlert(false)}
      />
      {/* )} */}
    </div>
  );
};

export default AdminManageView;
